<template>
<div id="focussection1">
  <v-card @mouseenter="mouseOver" flat :loading="loading" style="margin-top: 16px;padding-bottom:15px;">
      <Submenu :parentData="name" />
      <transition name="slide-x-transition" mode="out-in">
        <keep-alive>
          <component :is="dynamicComponent" @loading="loadingToggle"></component>
        </keep-alive>
      </transition>
  </v-card>
</div>
</template>

<script>
var moment = require("moment-timezone");
import Submenu from "@/components/Submenu/";
import PoolTimeline from "@/components/PoolTimeline/";
import TradingDiary from "@/components/TradingDiary/";
import TradePreparation from "@/components/TradePreparation/";
export default {
  name: "Section1",
  components: {
    Submenu,
    PoolTimeline,
    TradingDiary,
    TradePreparation
  },
  data() {
    return {
      name: "Section1",
      loading: true,
      date: moment
        .tz(Date.now(), this.$store.getters.timezone)
        .format("dddd - L | LT")
    };
  },
  methods: {
    loadingToggle(val) {
      this.loading = val;
    },
    mouseOver(){
       this.$store.dispatch("resetActivity", {section: this.name})
    }
  },
  computed: {
    dynamicComponent() {
      var menuIdx = this.$store.getters.userSubmenus[this.name].selected;
      return this.$store.getters.userSubmenus[this.name].items[menuIdx].component
    }
  },
  mounted(){    
    setInterval(() => {
      this.date = moment
        .tz(Date.now(), this.$store.getters.timezone)
        .format("dddd - L | LT")
    }, 1000);
  }
};
</script>

<style scoped>
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
